import { gql } from '@apollo/client';

export const UPDATE_UPS = gql`
  mutation updateProfile($updateUserInput: ups_updateUserInput!) {
    ups_updateUser(updateUserInput: $updateUserInput) {
      guildUuid
      firstName
      lastName
    }
  }
`;

export const UPSERT_CONTACT_UPS = gql`
  mutation upsertContact($upsertContact: ups_UpsertContactStrategyInput!) {
    ups_upsertContactStrategy(upsertContactStrategyInput: $upsertContact) {
      contactType
      contactTypeName
      guildUuid
      primary
      value
    }
  }
`;
